import PermissionsIconButton from "./PermissionsIconButton.vue";

export default PermissionsIconButton;
